import { z } from "zod";
import { PaginationSchema } from "../types";
import { ListPlanModelSchema } from "../dischargePlan/types";

/**
 * The record type return from the /terminals/ get endpoint
 */
export const ListTerminalModelSchema = z.object({
  id: z.number(),
  name: z.string(),
  shortName: z.string(),
});
export type ListTerminalModel = z.infer<typeof ListTerminalModelSchema>;

export const ListTerminalResponseSchema = z.array(ListTerminalModelSchema);
export type ListTerminalResponse = z.infer<typeof ListTerminalResponseSchema>;

export const ListPlanForTerminalResponseSchema = z.object({
  pagination: PaginationSchema,
  data: z.array(ListPlanModelSchema),
});

export type ListPlanForTerminalResponse = z.infer<
  typeof ListPlanForTerminalResponseSchema
>;
